module.exports = __webpack_public_path__ + "images/company/rank_medal/average_seconds_to_initial_reply_rank/4_da38ba07e5f798554a23a63c9194ecde.png";